const custom = {
    appHeaderHeight: "81px",
    drawerWidth: "240px",
    poolCardWidth: "264px",
};

export default custom;
